import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "./images/logo/companyLogo3.jpeg";

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState("home");

    const handleClick = (e, sectionId) => {
        e.preventDefault();
        setIsMenuOpen(false);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
            window.history.pushState({ sectionId }, "", `#${sectionId}`);
            setActiveSection(sectionId);
        }
    };

    const navItems = [
        { id: "home", label: "Home" },
        { id: "speakers", label: "Speakers" },
        { id: "team", label: "Team" },
        { id: "schedule", label: "Schedule" },
        { id: "sponsors", label: "Sponsors" },
    ];

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm shadow-lg transition-all duration-300">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center gap-3">
                        <a href="https://c3ihub.org" target="_blank" rel="noopener noreferrer">
                            {" "}
                            <img src={logo} className="max-w-28" />
                        </a>
                        <a
                            href="#home"
                            onClick={(e) => handleClick(e, "home")}
                            className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-blue-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
                        >
                            AICCTP
                        </a>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:block">
                        <div className="ml-10 flex items-center space-x-1">
                            {navItems.map((item) => (
                                <a
                                    key={item.id}
                                    href={`#${item.id}`}
                                    onClick={(e) => handleClick(e, item.id)}
                                    className={`relative px-3 py-2 rounded-md text-sm font-medium transition-all duration-300 
                                        ${activeSection === item.id ? "text-indigo-600" : "text-gray-600 hover:text-gray-900"}
                                        group
                                    `}
                                >
                                    {item.label}
                                    <span
                                        className={`absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 transform origin-left transition-transform duration-300 
                                            ${activeSection === item.id ? "scale-x-100" : "scale-x-0 group-hover:scale-x-100"}
                                        `}
                                    />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-indigo-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 transition-colors duration-200"
                        >
                            {isMenuOpen ? <X className="block h-6 w-6" /> : <Menu className="block h-6 w-6" />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0 pointer-events-none"}`}>
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/90 backdrop-blur-sm">
                    {navItems.map((item) => (
                        <a
                            key={item.id}
                            href={`#${item.id}`}
                            onClick={(e) => handleClick(e, item.id)}
                            className={`block px-3 py-2 rounded-md text-base font-medium transition-all duration-200 
                                ${activeSection === item.id ? "text-indigo-600 bg-indigo-50" : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"}
                            `}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
